const BASE = 'app/chugwars/';

const FETCH_STATE = BASE + 'FETCH_STATE';
const SET_STATE = BASE + 'SET_STATE';
const UPDATE_PLAYER_STATE = BASE + 'UPDATE_PLAYER_STATE';

export default {
  FETCH_STATE,
  SET_STATE,
  UPDATE_PLAYER_STATE,
};
